import { GovPerformCollectionData } from "./GovPoolModel/GovPerformCollection"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface SendResult {
  Success: boolean
  Text: string
  ImageData: string

}
export default function GovSendToLab(data: GovPerformCollectionData) {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<SendResult>("GovOrder/GovSendToLab", params)
}
export function GovMarkAsComplete(data: GovPerformCollectionData) {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<SendResult>("GovOrder/GovMarkAsComplete", params)
}